import styled from 'styled-components';
import { FONT_SIZE_7, FONT_WEIGHT_BOLD, INFO_COLOR } from '../../../styles/variables';
import { flexPosition } from '../../../styles/mixins';

export const OptionListItemDescriptionContent = styled.p`
  margin-bottom: 0;
`;

export const OptionListItemDescriptionButton = styled.button`
  background-color: transparent;
  border: none;
  font-size: ${FONT_SIZE_7};
  font-weight: ${FONT_WEIGHT_BOLD};
  padding: 0;
`;

export const OptionListItemDescription = styled.div`
  ${flexPosition({ align: 'flex-end', justify: 'space-between' })}
  margin-top: 10px;

  &:not(.opened) > ${OptionListItemDescriptionContent} {
    opacity: 0.5;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 200px;
  }

  &.opened > ${OptionListItemDescriptionContent} {
    margin-right: 15px;
    max-width: 85%;
    overflow-wrap: break-word;
  }
`;

export const OptionListItem = styled.div`
  background-color: ${INFO_COLOR};
  border-radius: 3px;
  color: #fff;
  margin-bottom: 5px;
  padding: 10px;
  font-size: ${FONT_SIZE_7};
  font-weight: bold;
  min-height: 33px;

  :last-child {
    margin-bottom: 0;
  }
`;

export const NameField = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 200px;
  width: 100%;
`;

export const OptionListItemField = styled.div`
  max-width: 200px;
  margin-right: 25px;
  flex-shrink: ${props => (props.noShrink ? 0 : 1)};
  width: ${props => (props.fullWidth ? '100%' : 'auto')};
`;

export const OptionPriceField = styled.div`
  margin-left: ${props => (props.hasSku ? '0px' : '80px')};
  margin-right: ${props => (props.hasSku ? '25px' : '0px')};
  flex-shrink: ${props => (props.noShrink ? 0 : 1)};
`;

export const OptionListItemButton = styled.button`
  background-color: transparent;
  border: none;
  margin: 0;
  opacity: 0.5;
  padding: 0 5px;
`;

export const OptionListItemData = styled.div`
  ${flexPosition({ align: 'center', justify: 'space-between' })}
  line-height: 1;
`;



// WEBPACK FOOTER //
// ./src/components/VariationOptionForm/VariationOptionItem/style.js